import { COMPONENT_TYPE } from 'common/constants';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock } from '../creation-types';

export const cmsRepeater = (): CreatedBuildingBlock<typeof COMPONENT_TYPE.CMS_REPEATER> =>
	createModel({
		type: COMPONENT_TYPE.CMS_REPEATER,
		editorProps: {
			expandable: true,
		},
		componentProps: {
			styles: {},
			other: {},
		},
		children: [],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.CMS_REPEATER>;
